import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import isNull from "lodash/isNull";

import classNames from "classnames";
import Tile from "shared/react_components/Tile";
import DonutChart from "shared/react_components/DonutChart";
import Accordion from "shared/react_components/Accordion";

import { score, ratio, points, chart } from "calls/styles/Scores.module.scss";
import { listItem, listItemFirst } from "calls/styles/CriteriaResultItem.module.scss";
import CriteriaResultItem from "calls/components/CriteriaResultItem";
import BadgeWithTooltip from "shared/react_components/BadgeWithTooltip";

const nameWithBadge = (name, score) => (
  <div className="d-flex align-items-center">
    {name}
    {isNull(score) && <BadgeWithTooltip color="warning" placement="top" name="N/A" className='ml-2'>
      <Row>
        <Col>
          Scorecard did not meet call qualification
        </Col>
      </Row>
    </BadgeWithTooltip>}
  </div>
);

const ScoreDetail = ({ color, scorecardName, totalScore, totalPossibleScore, criteriaDetails }) => (
  <Tile body className={score}>
    <DonutChart
      score={totalScore || 0}
      scoreMax={totalPossibleScore}
      color={color}
      className={chart}
    />
    <div className="d-flex justify-content-center align-items-baseline pt-3">
      <span className={classNames('pr-2', ratio)}>{totalScore || 0}/{totalPossibleScore}</span>
      <span className={points}>Points</span>
    </div>
    <Accordion title={nameWithBadge(scorecardName, totalScore)}>
      {
        criteriaDetails.map((item, i) =>
          <CriteriaResultItem
            key={i}
            condition={item.condition}
            score={item.score}
            explanation={item.explanation}
            className={ i === 0 ? listItemFirst : listItem }
          />)
      }
    </Accordion>
  </Tile>
);

ScoreDetail.propTypes = {
  color: PropTypes.string,
  scorecardName: PropTypes.string,
  totalScore: PropTypes.number,
  totalPossibleScore: PropTypes.number,
  criteriaDetails: PropTypes.arrayOf(
    PropTypes.shape({
      condition: PropTypes.string.isRequired,
      score: PropTypes.number,
      explanation: PropTypes.string
    })
  )
};

export default ScoreDetail;
